// Disable sign up submit until terms are agreed to
export function signUpOnlyIfTerms() {
  if (!$('#terms_sign_up').attr('checked')) {
    $('#sign_up_submit').attr('disabled', true);
  }
  $('#terms_sign_up').click(function() {
    if ($(this).attr('checked')) {
      $('#sign_up_submit').removeAttr('disabled');
    } else {
      $('#sign_up_submit').attr('disabled', true);
    }
  });
}
